import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";

type MedicalProvider = {
    id: string;
    companyName: string | null | undefined;
    address: string | null | undefined;
    roleName: string | null | undefined;
};

type ProviderSelectProps = {
    selectedProviderUUID: string;
    onProviderChange: (providerUUID: string) => void;
    providers: MedicalProvider[];
    label?: string;
};

const DockGenProviderSelect = ({
    selectedProviderUUID,
    onProviderChange,
    providers,
    label = "Select Medical Provider",
}: ProviderSelectProps) => {
    const formatProviderAddress = (provider: MedicalProvider) => {
        return `${provider.address ?? ""}`;
    };

    return (
        <Box sx={{ marginBottom: (theme) => theme.spacing(2) }}>
            <Typography
                variant="body2"
                sx={{
                    color: (theme) => theme.palette.primary.main,
                    fontWeight: 500,
                    marginBottom: (theme) => theme.spacing(1),
                    fontSize: "0.875rem",
                }}
            >
                {label}
            </Typography>
            <FormControl fullWidth size="small">
                <Select
                    value={selectedProviderUUID}
                    onChange={(e) => onProviderChange(e.target.value)}
                    displayEmpty
                    sx={{
                        fontSize: "0.875rem",
                        fontStyle: selectedProviderUUID ? "normal" : "italic",
                        color: selectedProviderUUID ? "inherit" : "text.secondary",
                    }}
                >
                    <MenuItem
                        value=""
                        disabled
                        sx={{ fontStyle: "italic", color: "text.secondary" }}
                    >
                        Select a provider...
                    </MenuItem>
                    {providers.length === 0 ? (
                        <MenuItem value="" disabled>
                            No providers available
                        </MenuItem>
                    ) : (
                        providers.map((provider) => (
                            <MenuItem key={provider.id} value={provider.id}>
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                        {`${provider.roleName} - ${provider.companyName}`}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {provider && formatProviderAddress(provider)}
                                    </Typography>
                                </Box>
                            </MenuItem>
                        ))
                    )}
                </Select>
            </FormControl>
        </Box>
    );
};

export default DockGenProviderSelect;
